import { render } from "./ProductList.vue?vue&type=template&id=2cdf05dd"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=2cdf05dd&lang=css"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__